<div class="flex-column">
  @for (locationsCountryGroup of groupedLocations | keyvalue; track locationsCountryGroup.key) {
    <app-delivery-report-location-country-group
      [locationsCountryGroup]="locationsCountryGroup"
      [isPrintView]="isPrintView()"
    ></app-delivery-report-location-country-group>
  }
</div>
